const pages = {
  home: {
    hero: {
      subtitle: "전략적 에너지 조달 컨설팅",
      title: "원유 및 LNG 전문 솔루션",
      titleHighlight: "조달",
      description: "Medigreen LLC는 원유 및 LNG 조달을 위한 전문 자문 서비스를 제공합니다. 풍부한 시장 전문 지식과 글로벌 네트워크를 결합하여 에너지 구매자에게 최적의 성과를 제공합니다.",
      ctaPrimary: "서비스 둘러보기",
      ctaSecondary: "무료 상담",
    },
    services: {
      sectionTitle: "서비스",
      title: "토탈 솔루션",
      titleHighlight: "for 에너지 조달",
      description: "시장 인텔리전스부터 계약 실행까지, Medigreen은 에너지 조달 전략을 최적화하기 위한 전 스펙트럼 자문 서비스를 제공합니다.",
      cta: "모든 서비스 보기",
      items: {
        crudeOil: {
          title: "원유 조달",
          desc: "공급업체 선정 및 시장 분석부터 계약 협상 및 물류 조정까지 원유 조달의 엔드투엔드 자문을 제공합니다.",
        },
        lng: {
          title: "LNG 조달 전략",
          desc: "장기 계약 구조화, 스팟 시장 최적화, 가격 리스크 관리를 포함한 포괄적인 LNG 조달 지원을 제공합니다.",
        },
        market: {
          title: "시장 분석 및 예측",
          desc: "글로벌 에너지 시장, 가격 동향, 수급 역학에 대한 독점적인 데이터 기반 분석으로 조달 결정을 지원합니다.",
        },
        contract: {
          title: "계약 협상 지원",
          desc: "복잡한 에너지 계약 협상에 대한 전문가 지침. 유리한 조건, 리스크 완화, 규제 준수를 보장합니다.",
        },
      },
    },
    about: {
      sectionTitle: "Medigreen LLC 소개",
      title: "신뢰할 수 있는 파트너",
      titleHighlight: "in 에너지 조달",
      description1: "Medigreen LLC는 원유 및 LNG 조달 자문에 특화된 컨설팅 회사입니다. 깊은 시장 지식과 엄격한 분석 역량을 결합하여 에너지 구매자가 최적의 조달 성과를 달성하도록 돕습니다.",
      description2: "국제 에너지 시장, 공급망 관리, 계약법에서 수십 년의 경험을 가진 숙련된 전문가 팀이 조달 협상에서 결정적인 경쟁 우위를 제공합니다.",
      cta: "더 알아보기",
      badge: {
        label: "글로벌 네트워크",
        value: "40+",
        sublabel: "국가 및 지역",
      },
      strengths: {
        global: {
          title: "글로벌 네트워크",
          desc: "중동, 동남아시아, 호주, 아메리카 대륙의 공급업체 및 거래 상대방에 대한 접근.",
        },
        risk: {
          title: "리스크 관리",
          desc: "고객의 비즈니스 요구에 맞춘 포괄적인 가격 리스크 및 공급 보안 전략.",
        },
        team: {
          title: "전문가 팀",
          desc: "국제 에너지 거래 및 조달에서 20년 이상의 실무 경험을 가진 컨설턴트.",
        },
      },
    },
    stats: {
      years: "업계 경험 연수",
      deals: "자문한 조달 거래",
      clients: "글로벌 에너지 고객",
      value: "조달 가치(USD)",
    },
    cta: {
      badge: "문의하기",
      title: "해결합시다",
      titleHighlight: "Your 에너지 과제를",
      heading: "에너지 조달 최적화를 준비하셨습니까?",
      description: "변동성이 큰 원유 시장을 탐색하든 장기 LNG 계약을 구조화하든, Medigreen의 전문가가 도와드립니다. 첫 상담은 무료입니다.",
      benefits: [
        "무료 초기 상담",
        "맞춤형 조달 전략",
        "글로벌 공급업체 네트워크 접근",
        "지속적인 시장 인텔리전스 지원",
      ],
      button: "무료 상담 예약",
    },
    news: {
      sectionTitle: "최신 뉴스",
      title: "시장 인사이트 및 업데이트",
      cta: "모든 뉴스 보기",
    },
  },
  services: {
    hero: {
      subtitle: "서비스 소개",
      title: "서비스",
      description: "원유 및 LNG 시장에서 최적의 성과를 달성하도록 설계된 포괄적인 에너지 조달 자문 서비스.",
    },
    items: {
      crudeOil: {
        title: "원유 조달 자문",
        desc: "공급업체 선정, 시장 분석, 가격 벤치마킹, 계약 협상을 포괄하는 포괄적인 원유 조달 자문 서비스를 제공합니다.",
        features: ["공급업체 선정 및 자격 검증", "가격 벤치마킹 및 시장 분석", "계약 구조화 및 협상", "물류 및 운송 조정", "품질 검사 지원"],
      },
      lng: {
        title: "LNG 조달 전략",
        desc: "LNG 자문 서비스를 통해 복잡한 글로벌 LNG 시장을 탐색하도록 돕습니다.",
        features: ["장기 계약 구조화", "스팟 및 단기 화물 조달", "가격 공식 최적화", "목적지 유연성 협상", "재기화 터미널 자문"],
      },
      market: {
        title: "시장 분석 및 가격 예측",
        desc: "Medigreen의 독점 분석 프레임워크는 실행 가능한 시장 인텔리전스를 제공합니다.",
        features: ["주간 및 월간 시장 보고서", "가격 시나리오 모델링", "공급 중단 리스크 평가", "수요 전망 분석", "경쟁사 조달 벤치마킹"],
      },
      contract: {
        title: "계약 협상 지원",
        desc: "경험 풍부한 협상가가 귀하의 팀과 함께 유리한 계약 조건을 확보합니다.",
        features: ["용어 시트 검토 및 작성", "가격 검토 조항 협상", "불가항력 및 책임 조항", "분쟁 해결 메커니즘", "규제 준수 검토"],
      },
      risk: {
        title: "공급망 리스크 관리",
        desc: "에너지 조달 포트폴리오 전반에 걸쳐 공급망 리스크를 식별, 평가 및 완화하는 데 도움을 드립니다.",
        features: ["공급 보안 평가", "거래 상대방 신용 리스크 분석", "지정학적 리스크 모니터링", "비상 공급 계획", "보험 및 헤지 자문"],
      },
      regulatory: {
        title: "규제 및 컴플라이언스 자문",
        desc: "국제 에너지 거래의 복잡한 규제 환경을 탐색하려면 전문 지식이 필요합니다.",
        features: ["수출입 규정 지침", "제재 준수 스크리닝", "환경 기준 자문", "탄소 발자국 평가", "정부 연계 지원"],
      },
    },
    cta: {
      title: "시작할 준비가 되셨습니까?",
      description: "오늘 무료 초기 상담을 위해 문의하시고 Medigreen이 에너지 조달 전략을 어떻게 혁신할 수 있는지 알아보세요.",
      button: "문의하기",
    },
  },
  about: {
    hero: {
      subtitle: "우리는 누구인가",
      title: "Medigreen LLC 소개",
      description: "전문성, 무결성, 그리고 고객 성과에 대한 끊임없는 집중을 기반으로 구축된 전문 에너지 조달 자문 회사.",
    },
    story: {
      subtitle: "우리의 이야기",
      title: "깊은 업계 전문성에 기반을 둔 설립",
      paragraphs: [
        "Medigreen LLC는 에너지 시장의 중요한 격차를 해소하기 위해 설립되었습니다.",
        "우리를 차별화하는 것은 업계 네트워크의 폭과 깊이입니다.",
        "이 광범위한 네트워크를 활용함으로써 Medigreen은 조언을 넘어서는 서비스를 제공합니다.",
      ],
      cta: "함께 일하기",
    },
    values: {
      subtitle: "우리의 가치",
      title: "우리를 움직이는 것",
      items: {
        integrity: { title: "무결성", desc: "완전한 투명성을 가지고 운영하며 항상 고객의 최선의 이익을 위해 행동합니다." },
        expertise: { title: "전문성", desc: "글로벌 에너지 시장에 대한 깊은 시장 지식과 수십 년의 실무 경험." },
        global: { title: "글로벌 도달", desc: "전 세계 공급업체, 트레이더 및 거래 상대방과의 확립된 관계." },
        results: { title: "결과 중심", desc: "고객의 수익에 제공하는 실질적인 가치로 성공을 측정합니다." },
      },
    },
    company: {
      subtitle: "회사 정보",
      title: "우리 사무실",
      address: "주소",
      phone: "전화",
      email: "이메일",
    },
    team: {
      subtitle: "우리의 사람들",
      title: "팀 만나기",
      members: {
        yasunori: {
          name: "Yasunori Kawauchi",
          title: "창립자 겸 CEO",
          bio: "글로벌 에너지 생산자, 트레이더, 금융 기관을 아우르는 광범위한 네트워크를 보유한 숙련된 리더.",
        },
        kevin: {
          name: "Kevin Yamazaki",
          title: "창립자 겸 CTO",
          bio: "Kevin은 디지털 인프라와 데이터 기반 시장 인텔리전스에 대한 깊은 전문 지식을 제공합니다.",
        },
      },
    },
  },
  contact: {
    hero: {
      subtitle: "연락하기",
      title: "문의하기",
      description: "에너지 조달 최적화를 준비하셨습니까? 무료 초기 상담을 위해 연락주세요.",
    },
    info: {
      subtitle: "우리 사무실",
      title: "대화를 시작합시다",
      description: "전문 조달 자문 지원을 찾는 에너지 구매자, 유틸리티 및 산업 기업의 문의를 환영합니다.",
      items: {
        address: "주소",
        phone: "전화",
        email: "이메일",
        hours: "영업 시간",
      },
      hoursValue: "월~금: 오전 9시 ~ 오후 6시(차모로 표준시)",
    },
    form: {
      title: "메시지 보내기",
      name: "성명 *",
      namePlaceholder: "홍길동",
      email: "이메일 주소 *",
      emailPlaceholder: "gildong@company.com",
      company: "회사",
      companyPlaceholder: "귀하의 회사명",
      subject: "제목",
      subjectOptions: [
        { value: "", label: "주제 선택..." },
        { value: "Crude Oil Procurement", label: "원유 조달" },
        { value: "LNG Procurement", label: "LNG 조달" },
        { value: "Market Analysis", label: "시장 분석" },
        { value: "Contract Negotiation", label: "계약 협상" },
        { value: "General Inquiry", label: "일반 문의" },
      ],
      message: "메시지 *",
      messagePlaceholder: "에너지 조달 요구사항에 대해 알려주세요...",
      charCount: "{count}/500",
      charError: "메시지는 500자를 초과할 수 없습니다.",
      submit: "보내기",
      sending: "전송 중...",
      error: "문제가 발생했습니다. 다시 시도해 주세요.",
      success: {
        title: "메시지 전송 완료!",
        description: "연락 주셔서 감사합니다. 1영업일 이내에 답변 드리겠습니다.",
      },
    },
  },
  news: {
    hero: {
      subtitle: "정보 얻기",
      title: "뉴스 및 인사이트",
      description: "Medigreen 팀의 시장 인텔리전스, 업계 분석 및 회사 업데이트.",
    },
    articles: {
      readMore: "더 읽기",
    },
  },
  caseStudies: {
    hero: {
      subtitle: "입증된 결과",
      title: "사례 연구",
      description: "실제 고객의 실제 결과. Medigreen이 에너지 조달 프로젝트에서 측정 가능한 가치를 제공한 방법을 살펴보세요.",
    },
    cta: {
      title: "다음 성공 사례가 되세요",
      description: "Medigreen이 에너지 조달 전략에서 측정 가능한 결과를 달성하도록 도와드립니다.",
      button: "대화 시작하기",
    },
  },
  notFound: {
    title: "페이지를 찾을 수 없음",
    description: "찾으시는 페이지가 존재하지 않거나 이동되었습니다.",
    button: "홈으로 돌아가기",
  },
  privacy: {
    hero: {
      subtitle: "법적 정보",
      title: "개인정보 처리방침",
      updated: "최종 업데이트: 2026년 4월 3일",
    },
    sections: [
      { title: "1. 소개", content: "Medigreen LLC(이하 '당사')는 귀하의 개인정보 보호에 최선을 다합니다. 본 개인정보 처리방침은 당사 웹사이트 방문 또는 자문 서비스 이용 시 정보를 수집, 사용, 공개 및 보호하는 방법을 설명합니다." },
      { title: "2. 수집하는 정보", content: "당사는 문의 양식 작성, 상담 요청 또는 이메일 소통 시 귀하가 자발적으로 제공하는 개인정보를 수집할 수 있습니다. 여기에는 이름, 이메일 주소, 회사명, 전화번호 및 에너지 조달 요구사항이 포함될 수 있습니다." },
      { title: "3. 정보 이용 방법", content: "수집한 정보는 문의 응답 및 자문 서비스 제공, 시장 인사이트 및 업데이트 전송(동의 시), 웹사이트 및 서비스 개선, 관련 법령 준수, 당사의 법적 권리 보호를 위해 사용됩니다." },
      { title: "4. 정보 공유", content: "당사는 귀하의 동의 없이 개인정보를 제3자에게 판매, 거래 또는 이전하지 않습니다. 단, 서비스 제공에 필요한 경우, 법적 의무 이행이 필요한 경우, 또는 당사의 권리 보호를 위해 필요한 경우는 예외입니다." },
      { title: "5. 데이터 보안", content: "당사는 개인정보의 무단 접근, 변경, 공개 또는 파괴를 방지하기 위해 적절한 기술적·조직적 조치를 시행합니다. 그러나 인터넷을 통한 전송 방법은 100% 안전하지 않으며, 절대적인 보안을 보장할 수 없습니다." },
      { title: "6. 쿠키", content: "당사 웹사이트는 브라우징 경험 향상을 위해 쿠키 및 유사한 추적 기술을 사용할 수 있습니다. 브라우저 설정에서 쿠키를 거부할 수 있으나, 일부 기능이 제대로 작동하지 않을 수 있습니다." },
      { title: "7. 제3자 링크", content: "당사 웹사이트에는 제3자 웹사이트 링크가 포함될 수 있습니다. 당사는 해당 사이트의 개인정보 처리 방침이나 콘텐츠에 대해 책임지지 않습니다." },
      { title: "8. 귀하의 권리", content: "귀하의 위치에 따라 개인정보에 대한 접근, 수정 또는 삭제 권리가 있을 수 있습니다. 이러한 권리를 행사하려면 info@medigreen.energy로 문의하십시오." },
      { title: "9. 정책 변경", content: "당사는 본 개인정보 처리방침을 수시로 업데이트할 수 있습니다. 변경 사항은 업데이트된 날짜와 함께 이 페이지에 게시됩니다. 변경 후 웹사이트를 계속 사용하면 새 정책에 동의한 것으로 간주됩니다." },
      { title: "10. 문의하기", content: "본 개인정보 처리방침에 관한 질문이 있으시면 연락주세요. Medigreen LLC, 1411 Pale San Vitores Road, Suite 303, Tamuning, GU | 이메일: info@medigreen.energy | 전화: +1.671.482.0104" },
    ],
  },
  terms: {
    hero: {
      subtitle: "법적 정보",
      title: "이용약관",
      updated: "최종 업데이트: 2026년 4월 3일",
    },
    sections: [
      { title: "1. 약관 동의", content: "Medigreen LLC 웹사이트(이하 '사이트')에 접속하고 사용함으로써 귀하는 본 이용약관에 동의하는 것으로 간주됩니다. 이 약관에 동의하지 않으시면 사이트를 사용하지 마십시오." },
      { title: "2. 사이트 이용", content: "귀하는 합법적인 목적으로만 이 사이트를 사용할 수 있습니다. 관련 법령 위반, 유해하거나 불쾌한 콘텐츠 전송, 사이트의 무단 접근 시도, 또는 사이트의 정상적인 기능 방해 행위는 금지됩니다." },
      { title: "3. 지적 재산권", content: "텍스트, 그래픽, 로고, 이미지를 포함한 이 사이트의 모든 콘텐츠는 Medigreen LLC의 재산이며 관련 지적 재산권법에 의해 보호됩니다. 당사의 명시적인 서면 허가 없이 복제, 배포 또는 파생 저작물을 만들 수 없습니다." },
      { title: "4. 자문 서비스 면책 조항", content: "이 사이트에 제공된 정보는 일반적인 정보 제공 목적으로만 제공되며 전문적인 자문, 법적 또는 재무적 조언을 구성하지 않습니다. Medigreen LLC의 자문 서비스 이용은 별도의 서면 계약에 따릅니다." },
      { title: "5. 책임 제한", content: "법률이 허용하는 최대 범위 내에서, Medigreen LLC는 이 사이트 사용 또는 여기에 제공된 정보에 대한 의존으로 인한 간접적, 부수적, 특별, 결과적 또는 징벌적 손해에 대해 책임지지 않습니다." },
      { title: "6. 기밀 유지", content: "문의 및 상담 요청을 포함하여 이 사이트를 통해 제출하는 모든 정보는 엄격한 기밀로 처리됩니다. 법률에 의해 요구되는 경우를 제외하고 귀하의 동의 없이 제3자에게 공개하지 않습니다." },
      { title: "7. 제3자 링크", content: "이 사이트에는 편의를 위해 제3자 웹사이트 링크가 포함될 수 있습니다. Medigreen LLC는 제3자 사이트의 콘텐츠, 개인정보 처리 방침 또는 관행에 대해 보증하거나 책임지지 않습니다." },
      { title: "8. 약관 수정", content: "Medigreen LLC는 언제든지 본 이용약관을 수정할 권리를 보유합니다. 변경 사항은 사이트에 게시된 즉시 효력이 발생합니다. 변경 후 사이트를 계속 사용하면 개정된 약관에 동의한 것으로 간주됩니다." },
      { title: "9. 준거법", content: "본 이용약관은 미국 괌의 법률에 따라 규율되고 해석됩니다." },
      { title: "10. 문의하기", content: "본 이용약관에 관한 질문이 있으시면 연락주세요. Medigreen LLC, 1411 Pale San Vitores Road, Suite 303, Tamuning, GU | 이메일: info@medigreen.energy | 전화: +1.671.482.0104" },
    ],
  },
};

export default pages;